import React, { ChangeEvent, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const InputContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

const InputWrapper = styled.div({
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  flex: 1,
});

const Input = styled.input<{ maxWidth?: string }>(
  ({ theme, width, height, maxWidth }) => ({
    width: width,
    maxWidth: maxWidth ? maxWidth : "",
    height: height,
    border: `1px solid ${theme.color.light_gray}`,
    padding: "1.6rem",
    borderRadius: "0",
    fontSize: "1.6rem",
  }),
);

interface CustomTextInputProps {
  name: string;
  type?: string;
  errorMessage?: string;
  width?: string;
  height?: string;
  placeholder?: string;
  alwaysShowMessage?: boolean;
  message?: string;
  serverError?: string;
  serverSuccess?: boolean;
  value?: string | number;
  readOnly?: boolean;
  hidden?: boolean;
  children?: React.ReactNode;
  error?: boolean;
  maxWidth?: string;
  min?: number;
  max?: number;
  mode?:
    | "none"
    | "text"
    | "decimal"
    | "numeric"
    | "tel"
    | "search"
    | "email"
    | "url";
  dir?: "rtl" | "ltr";
}

const NumberInput: React.FC<CustomTextInputProps> = ({
  name,
  type = "number",
  height = "5.2rem",
  width = "100%",
  placeholder = "",
  maxWidth,
  value,
  readOnly = false,
  hidden,
  children,
  mode = "numeric",
  dir = "ltr",
  max,
}) => {
  const { setValue, watch } = useFormContext();

  const { t } = useTranslation();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.replace(/,/g, "");
    setValue(name, newValue ? Number(newValue) : 0);
  };

  const currentValue = watch(name);
  // const formattedValue = currentValue ? currentValue.toLocaleString() : "";

  const formattedValue =
    currentValue === ""
      ? ""
      : isNaN(Number(currentValue))
        ? "0" // 0도 표시
        : Number(currentValue).toLocaleString();

  return (
    <InputContainer>
      <InputWrapper>
        <Input
          id={name}
          type="text"
          name={name}
          height={height}
          width={width}
          placeholder={t(placeholder)}
          value={formattedValue}
          readOnly={readOnly}
          hidden={hidden}
          inputMode={mode}
          maxWidth={maxWidth}
          dir={dir}
          onChange={handleChange}
          maxLength={max}
        />

        <span>{children}</span>
      </InputWrapper>
    </InputContainer>
  );
};

export default NumberInput;
